var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseLarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-186.056,249.83l4.206,4.206-1.294,1.294-4.206-4.206-4.206,4.206-1.294-1.294,4.206-4.206-4.206-4.206,1.294-1.294,4.206,4.206,4.206-4.206,1.294,1.294Z",
    transform: "translate(192.85 -244.33)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-large.0fbf9a37a8c8e6a3ff6d008335f4783b.svg";